(() => {
  'use strict';
  const bound = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const categories = new Set(['all', 'kits', 'refills', 'tools', 'custom']);

  function initialize(root = document) {
    root.querySelectorAll('[data-independent-shop]').forEach(shop => {
      if (bound.has(shop)) return;
      bound.add(shop);
      const links = [...shop.querySelectorAll('[data-independent-filter]')];
      const products = [...shop.querySelectorAll('[data-independent-product]')];
      const all = shop.querySelector('[data-independent-all]');
      const status = shop.querySelector('[data-independent-status]');
      const empty = shop.querySelector('[data-independent-empty]');
      const rail = shop.querySelector('[data-independent-rail]');
      const railNav = shop.querySelector('[data-independent-rail-nav]');
      const previous = shop.querySelector('[data-independent-previous]');
      const next = shop.querySelector('[data-independent-next]');
      const progress = shop.querySelector('[data-independent-rail-progress]');
      let scheduled = false;

      function refreshRail() {
        scheduled = false;
        if (!rail || !railNav) return;
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const overflows = maximum > 3;
        railNav.hidden = !overflows;
        if (previous) previous.disabled = !overflows || rail.scrollLeft <= 2;
        if (next) next.disabled = !overflows || rail.scrollLeft >= maximum - 2;
        if (progress) {
          const amount = overflows ? Math.min(100, (rail.clientWidth + rail.scrollLeft) / rail.scrollWidth * 100) : 100;
          progress.style.setProperty('--rail-progress', `${amount.toFixed(2)}%`);
        }
      }
      function queueRailRefresh() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(refreshRail);
      }
      function stepRail(direction) {
        if (!rail) return;
        const first = products.find(product => !product.hidden);
        const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap) || 17;
        const distance = first ? first.getBoundingClientRect().width + gap : rail.clientWidth * .85;
        rail.scrollBy({left: distance * direction, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      }

      links.forEach(link => link.addEventListener('click', event => {
        if (event.defaultPrevented || (event.button !== undefined && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const category = link.dataset.independentFilter;
        if (!categories.has(category)) return;
        const matching = products.filter(product => category === 'all' || product.dataset.category === category);
        event.preventDefault();
        products.forEach(product => { product.hidden = !matching.includes(product); });
        links.forEach(item => {
          const active = item === link;
          item.classList.toggle('is-active', active);
          if (item.tagName === 'BUTTON') {
            item.setAttribute('aria-pressed', String(active));
            item.removeAttribute('aria-current');
          } else if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        if (all && link.tagName !== 'BUTTON' && link.href) all.href = link.href;
        if (status) status.textContent = (status.dataset.countLabel || '').replace('[count]', String(matching.length));
        if (empty) empty.hidden = matching.length > 0;
        if (rail) rail.scrollLeft = 0;
        queueRailRefresh();
      }));

      const filterButtons = links.filter(link => link.tagName === 'BUTTON');
      filterButtons.forEach((button, index) => button.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        let target;
        if (event.key === 'ArrowRight') target = filterButtons[(index + 1) % filterButtons.length];
        else if (event.key === 'ArrowLeft') target = filterButtons[(index - 1 + filterButtons.length) % filterButtons.length];
        else if (event.key === 'Home') target = filterButtons[0];
        else if (event.key === 'End') target = filterButtons[filterButtons.length - 1];
        if (!target) return;
        event.preventDefault();
        target.focus();
        target.click();
      }));

      if (rail && railNav) {
        previous?.addEventListener('click', () => stepRail(-1));
        next?.addEventListener('click', () => stepRail(1));
        rail.addEventListener('scroll', queueRailRefresh, {passive: true});
        rail.addEventListener('keydown', event => {
          if (event.target !== rail || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (rail.scrollWidth - rail.clientWidth <= 3) return;
          event.preventDefault();
          stepRail(event.key === 'ArrowLeft' ? -1 : 1);
        });
        if ('ResizeObserver' in window) new ResizeObserver(queueRailRefresh).observe(rail);
        else window.addEventListener('resize', queueRailRefresh, {passive: true});
        refreshRail();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
